/**
 * "X of Y seats used" pill with a tiny progress bar. Counts active +
 * pending against the effective sub-delegate limit.
 */

type SeatUsagePillProps = {
  used: number;
  limit: number;
  /** True when `users.sub_delegate_limit` is NULL (column default applies). */
  isDefaultLimit?: boolean;
};

export function SeatUsagePill({ used, limit, isDefaultLimit = false }: SeatUsagePillProps) {
  const atLimit = used >= limit;
  const ratio = limit > 0 ? Math.min(used / limit, 1) : 0;

  return (
    <div
      className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1"
      data-testid="seat-usage-pill"
    >
      <span className="h-1.5 w-16 overflow-hidden rounded-full bg-gray-100">
        <span
          className={`block h-full rounded-full transition-all ${
            atLimit ? 'bg-red-500' : 'bg-[#026857]'
          }`}
          style={{ width: `${ratio * 100}%` }}
        />
      </span>
      <span className={`text-xs font-medium ${atLimit ? 'text-red-600' : 'text-gray-700'}`}>
        {used} of {limit} seats used
        {isDefaultLimit && <span className="ml-1 font-normal text-gray-400">(default)</span>}
      </span>
    </div>
  );
}
